import type { RouteObject } from "react-router";
import { GLOBAL_CONFIG } from "@/global-config";
import { Component } from "./utils";

export function getFrontendDashboardRoutes(): RouteObject[] {
  const frontendDashboardRoutes: RouteObject[] = [
    { path: "dashboard", element: Component("/pages/dashboard") },
    {
      path: "channels",
      children: [
        { index: true, element: Component("/pages/channels") },
        { path: "create", element: Component("/pages/channels/create") },
        { path: ":id", element: Component("/pages/channels/edit") },
      ],
    },
    {
      path: "clients",
      children: [
        { index: true, element: Component("/pages/clients") },
        { path: "create", element: Component("/pages/clients/create") },
        { path: ":id", element: Component("/pages/clients/edit") },
      ],
    },
    {
      path: "orders",
      children: [
        {
          index: true,
          element: Component("/pages/orders"),
          handle: { fullWidth: true },
        },
      ],
    },
    { path: "settings", element: Component("/pages/settings") },
    ...(GLOBAL_CONFIG.mockConfigEnabled ? [{ path: "mock-config", element: Component("/pages/mock-config") }] : []),
  ];
  return frontendDashboardRoutes;
}
